import React from "react";

import Home from "../Screens/User/Home";


const userRoutes = [
  { path: "/", component: <Home /> },
 
];

export { userRoutes };
